export default __webpack_public_path__ + "static/media/Bee_Falls_@_Pachmarhi.1e1e48c1.jpg";